import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import { FaFileImport } from "react-icons/fa";
import { createRoot } from "react-dom/client";
import L from "leaflet";

const ImportControl = ({ onImportClick }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const control = L.control({ position: "topright" });
    control.id = "import-Control";

    control.onAdd = function () {

      
      const frame = L.DomUtil.create("div", "leaflet-control leaflet-bar");
      
      frame.style.cssText = `
        background: rgba(255, 255, 255, 0.9);
        padding: 8px;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
      `;

      const btnStyle = `
        cursor: pointer;
        background: white;
        border-radius: 8px;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        transition: all 0.2s ease;
      `;


      const btnImport = L.DomUtil.create("div", "", frame);
      btnImport.style.cssText = btnStyle;
      btnImport.title = "Importer un fichier (DXF/KML)";

      createRoot(btnImport).render(<FaFileImport size={18} color="#2980b9" />);


      btnImport.onmouseenter = () => {
        btnImport.style.transform = "scale(1.1)";
        btnImport.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
        btnImport.style.background = "#f8f9fa";
      };
      
      btnImport.onmouseleave = () => {
        btnImport.style.transform = "scale(1)";
        btnImport.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
        btnImport.style.background = "white";
      };


      L.DomEvent.on(btnImport, "click", (e) => {
        L.DomEvent.stopPropagation(e);
        onImportClick();
      });

      return frame;
    };

    control.addTo(map);

    return () => {
      control.remove();
    };
  }, [map, onImportClick]);

  return null;
};

export default ImportControl;